import getScrollCallback from '../../../common/js/getScrollCallback'

require('normalize.css/normalize.css')
require('./styles/index.scss')
import 'core-js/features/array/from';
import 'core-js/features/array/find';
import 'core-js/features/array/for-each';
import 'intersection-observer';
import HandleScrollDown from '../../../common/js/HandleScrollDown'
import HandleSlideUp from '../../../common/js/HandleSlideUp'
import { getOffsetTop, getDataAttribute, handleBrowserScrollRestoration } from '../../../common/js/utils'
import WorldMap from './js/WorldMap'
import CampsSlide from './js/CampsSlide'
import EventBus from '../../../common/js/EventBus'
import initScrollEvent from '../../../common/js/initScrollEvent'
import Cta from '../../../common/js/Cta'
handleBrowserScrollRestoration();


const slides = Array.from(document.querySelectorAll('.slide'))
const getSlide = (slideNr) => {
  return slides.find(s => {
    let slide = getDataAttribute(s, 'slide')

   return parseInt(slide) === slideNr
  })
}

const toggleActiveClasses = (fromSlide, toSlide) => {
  const $fromSlide = getSlide(fromSlide)

  const $toSlide = getSlide(toSlide)

  $toSlide.classList.add('active')
  $fromSlide.classList.remove('active')
}

const doScrollDownTransition = (slide) => {
  slide = parseInt(slide)
  toggleActiveClasses(slide - 1, slide)
}

const doScrollUpTransition = (slide) => {
  slide = parseInt(slide)
  toggleActiveClasses(slide + 1, slide)
}


const getScrollCallbackParams = () => {
  const windowHeight = window.innerHeight

  const downTransitionPoints = {
    // 1: null,
    2: getOffsetTop(getSlide(2)) - windowHeight,
    3: getOffsetTop(getSlide(2)) + getSlide(2).offsetHeight - windowHeight,
    4: getOffsetTop(getSlide(3)) + getSlide(3).offsetHeight - windowHeight,
    5: getOffsetTop(getSlide(5)) - windowHeight,
    6: getOffsetTop(getSlide(6)) - windowHeight,
    7: getOffsetTop(getSlide(7)) - windowHeight,
  }

  const upTransitionPoints = {
    1: getOffsetTop(getSlide(2)),
    2: getOffsetTop(getSlide(2)) + getSlide(2).offsetHeight - windowHeight,
    3: getOffsetTop(getSlide(3)) + getSlide(3).offsetHeight - windowHeight,
    4: getOffsetTop(getSlide(4)) + getSlide(4).offsetHeight,
    5: getOffsetTop(getSlide(5)) + getSlide(5).offsetHeight,
    6: getOffsetTop(getSlide(6)) + getSlide(6).offsetHeight
    // 7: null,
  }

  return {
    downTransitionPoints,
    upTransitionPoints,
    doScrollDownTransition,
    doScrollUpTransition
  }
}

let scrollEventCallback = null
const onLoadCallback = () => {
  // Always start from the top.
  window.scrollTo(0, 0)
  initScrollEvent()

  scrollEventCallback = getScrollCallback(getScrollCallbackParams())
  EventBus.on('custom-scroll', scrollEventCallback)

  new WorldMap(getSlide(1))
  new CampsSlide(getSlide(3))
  new HandleSlideUp()
  new HandleScrollDown()

  new Cta(document.querySelector('#cta-link'))
  document.querySelector('#app').classList.add('loaded')
}

const onResizeCallback = () => {
  EventBus.off('custom-scroll', scrollEventCallback)
  scrollEventCallback = getScrollCallback(getScrollCallbackParams())
  EventBus.on('custom-scroll', scrollEventCallback)
}

window.addEventListener('load', onLoadCallback)
window.addEventListener('resize', onResizeCallback)